var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1280"
    }
  }, [_c('console-title', [_c('span', [_vm._v("상품목록")])]), _c('console-search', {
    on: {
      "search": function search($event) {
        _vm.page = 1;

        _vm.search(true);
      }
    }
  }, [_c('category-select', {
    attrs: {
      "categories": _vm.categories
    },
    on: {
      "input": function input($event) {
        _vm.page = 1;

        _vm.search(true);
      }
    },
    model: {
      value: _vm.filter._category,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "_category", $$v);
      },
      expression: "filter._category"
    }
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.recommendItems,
      "item-text": "text",
      "item-value": "value",
      "label": "추천 상품",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.filter.searchValue = null;
      }
    },
    model: {
      value: _vm.filter.isRecommend,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "isRecommend", $$v);
      },
      expression: "filter.isRecommend"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.mainItems,
      "item-text": "text",
      "item-value": "value",
      "label": "메인 상품",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.filter.searchValue = null;
      }
    },
    model: {
      value: _vm.filter.isMain,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "isMain", $$v);
      },
      expression: "filter.isMain"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.searchKeys,
      "item-text": "text",
      "item-value": "value",
      "label": "검색조건",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.filter.searchValue = null;
      }
    },
    model: {
      value: _vm.filter.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchKey", $$v);
      },
      expression: "filter.searchKey"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "검색어",
      "persistent-placeholder": "",
      "hide-details": "",
      "clearable": "",
      "disabled": !_vm.filter.searchKey
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.page = 1;

        _vm.search(true);
      }
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1)], 1)], 1), _c('console-body', [_c('v-layout', {
    staticClass: "align-end"
  }, [_c('span', {
    staticClass: "subtitle-2"
  }, [_vm._v("검색수 : " + _vm._s(_vm.summary.totalCount.format()))]), _c('v-spacer'), _c('span', [_c('v-btn', {
    staticClass: "primary--text px-2 ml-1",
    attrs: {
      "color": "white",
      "elevation": "1"
    },
    on: {
      "click": function click($event) {
        return _vm.updateNaverShopping(true);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-microsoft-excel")]), _vm._v("전체상품업데이트 ")], 1), _c('v-btn', {
    staticClass: "primary--text px-2 ml-1",
    attrs: {
      "color": "white",
      "elevation": "1"
    },
    on: {
      "click": function click($event) {
        return _vm.updateNaverShopping(false);
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-microsoft-excel")]), _vm._v("요약상품업데이트 ")], 1), _c('v-btn', {
    staticClass: "primary--text px-2 ml-1",
    attrs: {
      "color": "white"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.productRecomendUpdateDialog.open();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-microsoft-excel")]), _vm._v("추천상품변경 ")], 1), _c('v-btn', {
    staticClass: "primary--text px-2 ml-1",
    attrs: {
      "color": "white"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.productMainUpdateDialog.open();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-microsoft-excel")]), _vm._v("메인상품변경 ")], 1), _c('v-btn', {
    staticClass: "green--text px-2 ml-1",
    attrs: {
      "color": "white",
      "elevation": "1"
    },
    on: {
      "click": _vm.excel
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-microsoft-excel")]), _vm._v("엑셀다운로드 ")], 1)], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-2 mx-1 elevation-1",
    attrs: {
      "items": _vm.products,
      "item-key": "_id",
      "headers": _vm.productsHeaders,
      "hide-default-footer": "",
      "disable-sort": "",
      "disable-pagination": "",
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: "item.thumb",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "src": item.thumb,
            "max-width": "96",
            "height": "96",
            "contain": ""
          }
        });
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return _c('span', {}, [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))]);
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return _c('span', {}, [_c('v-icon', {
          staticClass: "mx-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v("mdi-pencil")]), _c('v-icon', {
          staticClass: "mx-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v("mdi-delete")])], 1);
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-pagination', {
    staticClass: "mt-3",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _c('v-btn', {
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "accent"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1), _c('excel-dialog', {
    ref: "excelDialog"
  }), _c('product-recomend-update-dialog', _vm._g({
    ref: "productRecomendUpdateDialog"
  }, {
    updateRecomendProduct: _vm.updateRecomendProduct
  })), _c('product-main-update-dialog', _vm._g({
    ref: "productMainUpdateDialog"
  }, {
    updateMainProduct: _vm.updateMainProduct
  }))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }